export const shareMediaConstants = {
    GET_CONVS_TO_SHARE_REQUEST: 'SHAREMEDIA/GET_CONVS_TO_SHARE_REQUEST',
    GET_CONVS_TO_SHARE_SUCCESS: 'SHAREMEDIA/GET_CONVS_TO_SHARE_SUCCESS',
    GET_CONVS_TO_SHARE_FAILURE: 'SHAREMEDIA/GET_CONVS_TO_SHARE_FAILURE',

    SEARCH_CONVS_TO_SHARE_REQUEST: 'SHAREMEDIA/SEARCH_CONVS_TO_SHARE_REQUEST',
    SEARCH_CONVS_TO_SHARE_SUCCESS: 'SHAREMEDIA/SEARCH_CONVS_TO_SHARE_SUCCESS',
    SEARCH_CONVS_TO_SHARE_FAILURE: 'SHAREMEDIA/SEARCH_CONVS_TO_SHARE_FAILURE',

    SEND_MEDIA_FILE_REQUEST: 'SHAREMEDIA/SEND_MEDIA_FILE_REQUEST',
    SEND_MEDIA_FILE_SUCCESS: 'SHAREMEDIA/SEND_MEDIA_FILE_SUCCESS',
    SEND_MEDIA_FILE_FAILURE: 'SHAREMEDIA/SEND_MEDIA_FILE_FAILURE',
}
